<template>
  <div style="padding: 0 10px 30px">
    <!--心理健康管理-->
    <div class="title-1">{{ mentalHealthObj.title }}</div>
    <div class="row-box flex-align-center" style="flex-wrap: wrap; padding: 0">
      <div v-for="(item, index) in mentalHealthObj.list" :key="index" class="pie-item">
        <PieChartCard v-if="index == 0" :item="item">
          <div class="flex-align-center">
            <!--时间标签-->
            <div class="flex-align-center tag-list">
              <div
                v-for="(item, index) in timeTagList3"
                :key="index"
                :class="{ 'list-tag-item': true, 'active-tag': mentalTagIndex == index }"
                @click="mentalTagIndex = index"
              >
                {{ item }}
              </div>
            </div>
            <a-range-picker v-model="mentalDateRange" style="width: 220px; margin: 0 15px" />
            <a-button icon="search" type="primary" @click="mentalQuery(true)">查询</a-button>
          </div>
        </PieChartCard>
        <MyPlan v-else :planData="item" />
      </div>
    </div>
    <!--重点关爱学生管理-->
    <div class="title-1">{{ mainCareStu.title }}</div>
    <div class="row-box flex-align-center" style="flex-wrap: wrap; padding: 0">
      <div v-for="(item, index) in mainCareStu.list" :key="index" class="pie-item">
        <PieChartCard :item="item" style="height: 340px" />
      </div>
    </div>
    <!--班主任工作管理-->
    <div class="child-full-width teacher-manage-bgColor" style="margin-top: 8px">
      <div class="title-1" style="margin-bottom: 10px">{{ remindStu.title }}</div>
      <div
        class="row-box flex-align-center"
        style="flex-wrap: wrap; padding: 0; background-color: #fff"
      >
        <!--提醒学生概况-->
        <div class="pie-item" style="padding: 0">
          <PieChartCard
            :item="remindStu.list[0]"
            :legendStyle="{ transform: 'translateY(-20px)' }"
            style="height: 360px; border: none"
          >
            <div class="flex-align-center">
              <!--时间标签-->
              <div class="flex-align-center tag-list">
                <div
                  v-for="(item, index) in timeTagList3"
                  :key="index"
                  :class="{ 'list-tag-item': true, 'active-tag': remindStuTagIndex == index }"
                  @click="remindStuTagIndex = index"
                >
                  {{ item }}
                </div>
              </div>
              <a-range-picker v-model="remindStuDateRange" style="width: 220px; margin: 0 15px" />
              <a-button icon="search" type="primary" @click="remindStuQuery(true)">查询</a-button>
            </div>
          </PieChartCard>
        </div>
        <div class="pie-item" style="height: 380px; padding: 0">
          <ClassTeaHandSituat ref="classTeaHandSituatRef" />
        </div>
      </div>
      <!--提醒人次-->
      <ReminderNumCard style="height: 340px; margin: 15px 0 20px 0" />
    </div>
    <!--总体数据概览-->
    <div class="title-1" style="margin-bottom: 15px">{{ dataOverview.title }}</div>
    <a-row :gutter="[15, 15]" class="row-box" style="background-color: #fff">
      <a-col v-for="(item, index) in dataOverview.list" :key="index" :span="6">
        <a-card class="key-point-item" :style="{ backgroundColor: item.backgroundColor }">
          <div class="title-1" :style="{ color: '#fff' }">
            {{ item.label }}
          </div>
          <div :style="{ marginTop: '20px', color: '#fff' }">
            <span class="number-value">
              <CountAnimation :end-val="item.value" />
            </span>
            {{ index > 0 ? '次' : '人' }}
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CountAnimation from '@/components/CountAnimation'
import { getAction } from '@api/manage'
import PieChart from '@/components/echartZyz/components/PieChart'
import PieChartCard from '@/comUi/PieChartCard'
import MyPlan from './components/MyPlan.vue'
import ReminderNumCard from '@/comUi/ReminderNumCard'
import ClassTeaHandSituat from '@/comUi/ClassTeaHandSituat'
import { formatYearMonthDate, getMonthDateRange, getWeekDateRange } from '@/utils/date'
import { getSchoolTerm } from '@/utils/termDate'
const { startDate, endDate } = getSchoolTerm()
const dateRangMapObj = {
  0: getWeekDateRange(), // 本周日期范围
  1: getMonthDateRange(), // 本月日期范围
  2: [startDate, endDate], // 本学期日期范围
}

export default {
  name: 'MentaWorkbench',
  components: {
    CountAnimation,
    // CreatePlan,
    PieChart,
    PieChartCard,
    MyPlan,
    ReminderNumCard,
    ClassTeaHandSituat,
  },
  computed: {
    ...mapGetters(['identityId']),
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryParam: {},
      loading: true,
      timeTagList: [
        {
          label: '本周',
          value: 'week',
        },
        {
          label: '本月',
          value: 'month',
        },
        {
          label: '本学期',
          value: 'term',
        },
      ],
      tagItemIndex: 0,
      headCardList: [
        {
          title: '今日校园动态',
          backgroundColor: '#009cfa',
          contentList: [
            {
              label: '心情提醒',
              value: 0,
            },
            {
              label: '班级提醒',
              value: 0,
            },
            {
              label: '心情记录',
              value: 0,
            },
          ],
        },
        {
          title: '今日校园心情',
          backgroundColor: '#23cdad',
          contentList: [
            {
              label: '正常人数',
              value: 0,
            },
            {
              label: '提醒人数',
              value: 0,
            },
            {
              label: '关爱人数',
              value: 0,
            },
          ],
        },
        {
          title: '学校基本信息',
          backgroundColor: '#725be9',
          contentList: [
            {
              label: '学生人数',
              value: 0,
            },
            {
              label: '心理老师访问次数',
              value: 0,
            },
            {
              label: '教师访问次数',
              value: 0,
            },
          ],
        },
      ],
      stuCardList: [
        {
          title: '重点关爱学生',
          list: [
            {
              value: 0,
              key: 'zgaCnt',
              label: '重点关爱学生数',
              backgroundColor: '#F66860',
              value2: 0,
              key2: 'zgaCnt2',
              label2: '已关爱学生次数',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '待评估学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
          ],
        },
        {
          title: '小叮当提醒学生',
          list: [
            {
              value: 100,
              label: '提醒学生',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              label: '已查看学生数',
            },
            {
              value: 0,
              label: '已归档学生数',
            },
          ],
        },
      ],
      planList: [],
      mentalHealthObj: {
        title: '心理健康管理',
        list: [
          {
            title: '心理辅导',
            showTagList: true,
            path: '/CommonPage/PsyCounselAppointment',
            chartData: [
              { value: 0, name: '预约未确认' },
              { value: 0, name: '未辅导' },
              { value: 0, name: '已辅导' },
            ],
            pieText: [0, '总辅导次数'],
            subTitle: '心理辅导预约处理率',
            legendArr: [
              { value: 0, name: '辅导记录', loading: true  },
              { value: 0, name: '班主任预约', loading: true },
              { value: 0, name: '家长预约', loading: true },
              { value: 0, name: '危机上报', loading: true },
            ],
            rate: 0,
          },
          {
            title: '我的计划',
            chartData: [
              {
                value: 0,
                name: '心理测评计划',
              },
              { value: 0, name: '待心理评估学生' },
              {
                value: 0,
                name: '校园活动计划',
              },
            ],
          },
        ],
      },
      timeTagList3: ['本周', '本月', '本学期', '全部'],
      mentalTagIndex: 0,
      mentalDateRange: [],
      remindStuTagIndex: 0,
      remindStuDateRange: [],
      mainCareStu: {
        title: '重点关爱学生管理',
        list: [
          {
            title: '重点学生概览',
            path: '/CommonPage/MainCareStuOverview',
            chartData: [
              { value: 0, name: '一级学生人数' },
              { value: 0, name: '二级学生人数' },
              { value: 0, name: '三级学生人数' },
            ],
            pieText: [0, '总人数'],
          },
          {
            title: '重点学生关爱情况',
            path: '/CommonPage/MainStuCareSituation',
            chartData: [
              { value: 0, name: '待关爱学生数' },
              { value: 0, name: '已关爱学生数' },
            ],
            pieText: [0, '总人数'],
            legendArr: [
              { value: 0, name: '累计关爱次数', isNotHasDetail: true },
              { value: 0, name: '待关爱学生数' },
              { value: 0, name: '已关爱学生数' },
            ],
          },
        ],
      },
      remindStu: {
        title: '班主任工作管理',
        list: [
          {
            title: '班主任提醒处理情况',
            subTitle: '教师提醒名单关爱率',
            showTagList: true,
            rate: 0,
            hideLegend: true,
            path: '/CommonPage/XddRemindStudent',
            chartData: [
              { value: 0, name: '已处理提醒数' },
              { value: 0, name: '未处理提醒数' },
            ],
            pieText: [0, '总提醒数'],
          },
        ],
      },
      dataOverview: {
        title: '整体数据概览',
        list: [
          {
            value: 0,
            key: 'careListCnt',
            label: '总重点关爱学生数',
            backgroundColor: '#F66860',
          },
          {
            value: 0,
            key: 'txCnt',
            label: '总提醒次数',
            backgroundColor: '#1783E8',
          },
          {
            value: 0,
            key: 'zgaCnt',
            label: '总关爱次数',
            backgroundColor: '#725BE9',
          },
          {
            value: 0,
            key: 'planCnt',
            label: '心理测评次数',
            backgroundColor: '#FA9600',
          },
          {
            value: 0,
            key: 'pgCnt',
            label: '总评估次数',
            backgroundColor: '#13B999',
          },
          {
            value: 0,
            key: 'gyCnt',
            label: '总干预学生次数',
            backgroundColor: '#13B999',
          },
          {
            value: 0,
            key: 'bzrgtCnt',
            label: '班主任沟通次数',
            backgroundColor: '#13B999',
          },
          {
            value: 6,
            key: 'jxgtCnt',
            label: '家校沟通次数',
            backgroundColor: '#13B999',
          },
        ],
      },
    }
  },
  created() {
    this.getHeadCardData()
    this.getPlanList()
    this.getWordView()
    this.getKeyCareStudents()
    this.getMyPlansCount()
  },
  mounted() {
    this.$refs.classTeaHandSituatRef.getReminderDataList({
      timeType: 'week',
    })
  },
  watch: {
    mentalTagIndex: {
      handler(val) {
        if (val == -1) return
        this.mentalDateRange = dateRangMapObj[val]
        this.mentalQuery()
      },
      immediate: true,
    },
    remindStuTagIndex: {
      handler(val) {
        if (val == -1) return
        this.remindStuDateRange = dateRangMapObj[val]
        this.remindStuQuery()
      },
      immediate: true,
    },
  },
  methods: {
    toggleTagItem(index) {
      this.tagItemIndex = index
    },
    getHeadCardData() {
      // 校园动态
      this.loading = true
      getAction('/statistic/todaySchoolDynamic').then((res) => {
        if (res.success) {
          const { mood_warn, class_warn, mood_records } = res.result
          const contentList = [
            {
              label: '心情提醒',
              value: mood_warn || 0,
            },
            {
              label: '班级提醒',
              value: class_warn || 0,
            },
            {
              label: '心情记录',
              value: mood_records || 0,
            },
          ]
          this.$set(this.headCardList[0], 'contentList', contentList)
        }
      })
      // 校园心情
      getAction('/statistic/todaySchoolMood', this.queryParam).then((res) => {
        if (res.success) {
          const { normalPeople, needCarePeople, carePeople } = res.result
          const contentList = [
            {
              label: '正常人数',
              value: normalPeople || 0,
            },
            {
              label: '提醒人数',
              value: needCarePeople || 0,
            },
            {
              label: '关爱人数',
              value: carePeople || 0,
            },
          ]
          this.$set(this.headCardList[1], 'contentList', contentList)
        }
      })
      // 学校基本信息
      getAction('/statistic/schoolBasicInfo', this.queryParam).then((res) => {
        if (res.success) {
          const { studentCount, teacherCount, parentVisitAvg } = res.result
          const contentList = [
            {
              label: '学生人数',
              value: studentCount || 0,
            },
            {
              label: '心理老师访问次数',
              value: parentVisitAvg || 0,
            },
            {
              label: '教师访问次数',
              value: teacherCount || 0,
            },
          ]
          this.$set(this.headCardList[2], 'contentList', contentList)
        }
      })
      setTimeout(() => {
        this.loading = false
      }, 200)
    },
    // 心理辅导
    async getStudentCounselingData() {
      const res = await getAction('/AppTwo/getStudentCounselingData', {
        beginDate: this.mentalDateRange?.[0],
        endDate: this.mentalDateRange?.[1],
      })
      const pcRes = await getAction('/statisticV2/getPcAllTutoringCount', {
        beginDate: this.mentalDateRange?.[0],
        endDate: this.mentalDateRange?.[1],
        role: this.identityId,
      })
      const totalcounsel = pcRes.result?.total
      const totalWithFeedbackCount = pcRes.result?.totalWithFeedbackCount
      const { success, result } = res
      if (success) {
        const {
          unconfirmedCount,
          unTutoredCount,
          tutoredCount,
          teacherBookingTotal,
          parentBookingTotal,
          totalAppointNum,
          mentalBookingRate,
        } = result
        const chartData = [
          { value: unconfirmedCount, name: '预约未确认' },
          { value: unTutoredCount, name: '未辅导' },
          { value: tutoredCount, name: '已辅导' },
        ]
        const legendArr = [
          { value: totalcounsel, name: '辅导记录', path: '/CommonPage/CommonReminder' , type: 2 ,query: { commonType: 'counseling' }, loading: false  },
          { value: teacherBookingTotal, name: '班主任预约', path: '/CommonPage/PsyCounselAppointment' , type: 1, loading: false },
          { value: parentBookingTotal, name: '家长预约', path: '/CommonPage/PsyCounselAppointment' , type: 2, loading: false },
          { value: totalWithFeedbackCount, name: '危机上报', path: '/CommonPage/CommonReminder' , type: 4 ,query: { commonType: 'crisis' }, loading: false },
        ]
        this.$set(this.mentalHealthObj.list[0], 'chartData', chartData)
        this.$set(this.mentalHealthObj.list[0], 'pieText', [totalAppointNum, '总辅导次数'])
        this.$set(this.mentalHealthObj.list[0], 'legendArr', legendArr)
        this.$set(this.mentalHealthObj.list[0], 'rate', mentalBookingRate)
      }
    },
    getPlanList() {
      this.planList = []
      getAction('/schoolEvaluationPlan/list', { pageNo: 1, pageSize: 5 }).then((res) => {
        if (res.success) {
          const planList = res.result.records.map((item) => ({
            ...item,
            id: item.id,
            title: item.name,
            status: item.status,
            time: item.createTime,
            rate: (item.finishStudentNum / item.planStudentNum).toFixed(2) * 100,
            color: '#1783E8',
            tag: 0,
          }))
          this.planList.push(...planList)
        }
      })
      getAction('/schoolActivityPlan/list', { pageNo: 1, pageSize: 5 }).then((res) => {
        if (res.success) {
          console.log('活动计划：', res.result)
          const activityPlanList = res.result.records.map((item) => ({
            ...item,
            id: item.id,
            title: item.title,
            status: item.status,
            time: item.createTime,
            rate: (item.finishClassNum / item.planClassNum).toFixed(2) * 100,
            color: '#1783E8',
            tag: 1,
          }))
          this.planList.push(...activityPlanList)
        }
      })
      console.log('计划列表：', this.planList)
    },
    // 重点学生概览
    async getKeyCareStudents() {
      const res = await getAction('/statisticV2/getKeyCareStudents')
      const { success, result } = res
      if (success) {
        const mainStuView = {
          ...result,
          chartData: result.chartData.filter((item) => item.type != 4),
          legendArr: result.chartData,
          path: '/CommonPage/MainCareStuOverview',
        }
        this.$set(this.mainCareStu.list, '0', mainStuView)
        const findItem = mainStuView.chartData.find((item) => item.type == 4)
        if (findItem) {
          this.$set(findItem, 'color', '#FA3A25')
        }
      }
    },
    // 提醒学生概况
    async getReminderData() {
      const res = await getAction('/statisticV2/getReminderData', {
        beginDate: this.remindStuDateRange?.[0],
        endDate: this.remindStuDateRange?.[1],
      })
      const {
        success,
        result: { doneNum, pendingNum, totalNum, processRate },
      } = res
      if (success) {
        const chartData = [
          { value: doneNum, name: '已处理提醒人次' },
          { value: pendingNum, name: '未处理提醒人次' },
        ]
        const pieText = [totalNum, '总提醒人次']
        this.$set(this.remindStu.list[0], 'chartData', chartData)
        this.$set(this.remindStu.list[0], 'pieText', pieText)
        this.$set(this.remindStu.list[0], 'rate', processRate)
      }
    },
    // 我的计划-心理老师
    async getMyPlansCount() {
      const res = await getAction('/statisticV2/getMyPlansCount')
      const {
        success,
        result: { schoolActivityCount, schoolEvaluationPlanCount, schoolEvaluationPlanResultCount },
      } = res
      if (success) {
        const chartData = [
          {
            value: schoolEvaluationPlanCount,
            name: '心理测评计划',
            path: '/CommonPage/MyWordPlan',
            query: { radioKey: 2 },
          },
          {
            value: schoolEvaluationPlanResultCount,
            name: '待心理评估学生',
            path: '/CommonPage/PsyScaleEvaluat',
          },
          {
            value: schoolActivityCount,
            name: '校园活动计划',
            path: '/CommonPage/MyWordPlan',
            query: { radioKey: 1 },
          },
        ]
        this.$set(this.mentalHealthObj.list[1], 'chartData', chartData)
      }
    },
    getWordView() {
      getAction('/home/psychologyTeacherWorkbench', this.queryParam).then((res) => {
        const { success, result } = res
        console.log('result', result)
        if (success) {
          // 重点学生关爱情况
          const { ygaStudentCnt, dgaStudentCnt, zgaCnt } = result
          const chartData1 = [
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
          ]
          const legendArr1 = [
            { value: zgaCnt, name: '累计关爱次数', isNotHasDetail: true },
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
          ]
          const total1 = chartData1.reduce((acc, cur) => acc + cur.value, 0)
          this.$set(this.mainCareStu.list[1], 'chartData', chartData1)
          this.$set(this.mainCareStu.list[1], 'legendArr', legendArr1)
          this.$set(this.mainCareStu.list[1], 'pieText', [total1, '总人数'])

          // 整体数据概览数据
          const keys = Object.keys(result)
          if (!keys.length) return
          keys.forEach((key) => {
            const item = result[key]
            const index = this.dataOverview.list.findIndex((i) => {
              return i.key == key
            })
            if (index == -1) return
            this.$set(this.dataOverview.list[index], 'value', item)
          })
        }
      })
    },
    // 心理辅导模块查询
    async mentalQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.mentalTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: this.mentalDateRange?.[0] && formatYearMonthDate(this.mentalDateRange[0]),
        endDate: this.mentalDateRange?.[1] && formatYearMonthDate(this.mentalDateRange[1]),
      }
      // 格式化数组日期格式
      this.mentalDateRange = [dateRangeObj?.beginDate, dateRangeObj?.endDate]
      this.$set(this.mentalHealthObj.list[0], 'query', dateRangeObj)
      await this.getStudentCounselingData()
    },
    async remindStuQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.remindStuTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: this.remindStuDateRange?.[0] && formatYearMonthDate(this.remindStuDateRange[0]),
        endDate: this.remindStuDateRange?.[1] && formatYearMonthDate(this.remindStuDateRange[1]),
      }
      // 格式化数组日期格式
      this.remindStuDateRange = [dateRangeObj?.beginDate, dateRangeObj?.endDate]
      await this.getReminderData()
      // dom生成之后再调用
      if (this.$refs.classTeaHandSituatRef) {
        await this.$refs.classTeaHandSituatRef.getReminderDataList(dateRangeObj)
      }
    },
  },
}
</script>
<style scoped lang="less">
.row-box {
  padding: 20px 10px;
  margin-bottom: 10px;
  border-radius: 8px;
}
.pie-item {
  width: 50%;
  padding: 10px 12px;
  &:nth-child(odd) {
    padding-left: 0;
  }
  &:nth-child(even) {
    padding-right: 0;
  }
}

.tag-list {
  .list-tag-item {
    width: 54px;
    height: 24px;
    margin: 6px;
    line-height: 24px;
    text-align: center;
    background: #eff4fc;
    border-radius: 4px;
    color: #404040;
    font-size: 12px;
    cursor: pointer;
  }
  .active-tag {
    background: #009dff;
    color: #fff;
  }
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 15px;
  padding: 0px 20px;
}

.key-point-item {
  height: 140px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.number-value {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}
</style>
